import { SetStateAction, Dispatch, PropsWithChildren, FC } from 'react'
import { Checkbox, Tag } from 'antd'
import { CheckboxValueType } from 'antd/lib/checkbox/Group'
import { JOB_REQUEST_STATUS_FOR_LIST } from '@OpsQuality/constants'
import {
    INSPECTION_STATUS_FILTER,
    PRIORITY_DISPLAY_VALUES,
} from '@OpsQuality/JobRequestList/constants'

interface FilterPropsType {
    pendingFilters?: string[] | null
    selectedFilters: string[]
    options?: {
        label: string
        value: string
    }[]
    setCheckboxFilter: Dispatch<SetStateAction<string[] | undefined | null>>
    filterName?: string
}

export const DrawerCheckbox: FC<PropsWithChildren<FilterPropsType>> = props => {
    const {
        pendingFilters,
        selectedFilters,
        options,
        setCheckboxFilter,
        filterName,
    } = props

    const getOptions = () => {
        if (filterName === 'priority') {
            return Object.keys(PRIORITY_DISPLAY_VALUES).map(priority => ({
                label: PRIORITY_DISPLAY_VALUES[
                    priority as keyof typeof PRIORITY_DISPLAY_VALUES
                ],
                value: priority,
            }))
        }

        if (filterName === 'status') {
            return [...new Set(Object.values(JOB_REQUEST_STATUS_FOR_LIST))].map(
                eachLabel => ({
                    label: eachLabel,
                    value: eachLabel,
                }),
            )
        }

        return options
    }

    return (
        <Checkbox.Group
            style={{
                display: 'flex',
                flexDirection: 'column',
            }}
            onChange={(selectedValues: CheckboxValueType[]) =>
                setCheckboxFilter(selectedValues as string[])
            }
            value={pendingFilters || selectedFilters}
            options={getOptions()}
        />
    )
}

export const CheckboxAppliedFilter: FC<
    PropsWithChildren<{
        onCloseTag: (selectedFilters: string[], filterTitle: string) => void
        options?: { label: string; value: string }[]
        selectedValues: string[]
        currentId: string
        filterTitle: string
    }>
> = props => {
    const { onCloseTag, options, selectedValues, currentId, filterTitle } =
        props
    const selectedFilters = selectedValues.filter(
        eachValue => eachValue !== currentId,
    )

    return (
        <Tag
            closable
            key={currentId}
            onClose={() => {
                onCloseTag(selectedFilters, filterTitle)
            }}
        >
            {`${filterTitle}: ${
                options?.find(option => option.value === currentId)?.label ||
                'Unknown'
            }`}
        </Tag>
    )
}

interface InspectionTagFilterPropsType {
    inspectionStatus: string[] | null
    onClose: (remainingInspectionStatusFilter: string[]) => void
}
export const InspectionTagFilter: FC<InspectionTagFilterPropsType> = ({
    inspectionStatus,
    onClose,
}) => {
    if (!inspectionStatus) {
        return null
    }
    return (
        <>
            {inspectionStatus.map(status => {
                const remainingInspectionStatusFilter = inspectionStatus.filter(
                    currentStatus => currentStatus !== status,
                )
                const label = INSPECTION_STATUS_FILTER.find(
                    filterStatus => filterStatus.value === status,
                )?.label

                return (
                    <Tag
                        closable
                        key={status}
                        onClose={() => onClose(remainingInspectionStatusFilter)}
                    >
                        {`Inspection status: ${label}`}
                    </Tag>
                )
            })}
        </>
    )
}
